import React from 'react';
import { ContactForm } from '../components/ContactForm';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
export const ContactUs = () => {
  const openingHours = [{
    day: 'Monday',
    hours: '9:00am – 5:00pm'
  }, {
    day: 'Tuesday',
    hours: '9:00am – 5:00pm'
  }, {
    day: 'Wednesday',
    hours: '9:00am – 5:00pm'
  }, {
    day: 'Thursday',
    hours: '9:00am – 5:00pm'
  }, {
    day: 'Friday',
    hours: '9:00am – 5:00pm'
  }, {
    day: 'Saturday',
    hours: 'Closed'
  }, {
    day: 'Sunday',
    hours: 'Closed'
  }];
  return <div className="w-full" data-id="element-241">
      {/* Hero Section with Map Background */}
      <div className="relative bg-dark py-16 md:py-24 w-full" style={{
      backgroundImage: `url('https://images.unsplash.com/photo-1524661135-423995f22d0b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }} data-id="element-242">
        <div className="absolute inset-0 bg-primary/70" data-id="element-243"></div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-244">
          <h1 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-245">
            Contact Us
          </h1>
          <p className="text-xl text-white/90 max-w-3xl" data-id="element-246">
            We're here to help with all your appliance repair and maintenance
            needs. Reach out to our friendly team today.
          </p>
        </div>
      </div>
      {/* Contact Information & Form */}
      <section className="py-16 bg-light" data-id="element-247">
        <div className="container mx-auto px-4" data-id="element-248">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-249">
            {/* Contact Info */}
            <div data-id="element-250">
              <h2 className="text-3xl font-bold text-primary mb-8" data-id="element-251">
                Get in Touch
              </h2>
              <div className="bg-white rounded-lg shadow-md p-6 md:p-8 mb-8" data-id="element-252">
                <div className="space-y-6" data-id="element-253">
                  <div className="flex items-start" data-id="element-254">
                    <div className="bg-primary/10 p-3 rounded-full mr-4" data-id="element-255">
                      <MapPin className="text-primary" size={24} data-id="element-256" />
                    </div>
                    <div data-id="element-257">
                      <h3 className="font-bold text-dark mb-1" data-id="element-258">Our Address</h3>
                      <p className="text-gray-600" data-id="element-259">
                        78 Austhorpe Rd, Leeds LS15 8EF
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-260">
                    <div className="bg-primary/10 p-3 rounded-full mr-4" data-id="element-261">
                      <Phone className="text-primary" size={24} data-id="element-262" />
                    </div>
                    <div data-id="element-263">
                      <h3 className="font-bold text-dark mb-1" data-id="element-264">Phone Number</h3>
                      <p className="text-gray-600" data-id="element-265">
                        <a href="tel:08000554969" className="hover:text-secondary" data-id="element-266">
                          0800 055 4969
                        </a>
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-267">
                    <div className="bg-primary/10 p-3 rounded-full mr-4" data-id="element-268">
                      <Mail className="text-primary" size={24} data-id="element-269" />
                    </div>
                    <div data-id="element-270">
                      <h3 className="font-bold text-dark mb-1" data-id="element-271">
                        Email Address
                      </h3>
                      <p className="text-gray-600" data-id="element-272">
                        <a href="mailto:rawalraj2057@gmail.com" className="hover:text-secondary" data-id="element-273">
                          rawalraj2057@gmail.com
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* Opening Hours */}
              <div className="bg-white rounded-lg shadow-md p-6 md:p-8" data-id="element-274">
                <div className="flex items-center mb-4" data-id="element-275">
                  <Clock className="text-primary mr-3" size={24} data-id="element-276" />
                  <h3 className="text-xl font-bold text-primary" data-id="element-277">
                    Opening Hours
                  </h3>
                </div>
                <div className="space-y-2" data-id="element-278">
                  {openingHours.map((item, index) => <div key={index} className="flex justify-between items-center py-2 border-b border-gray-100 last:border-0" data-id="element-279">
                      <span className="font-medium text-dark" data-id="element-280">{item.day}</span>
                      <span className="text-gray-600" data-id="element-281">{item.hours}</span>
                    </div>)}
                </div>
              </div>
            </div>
            {/* Contact Form */}
            <div data-id="element-282">
              <ContactForm data-id="element-283" />
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-16 bg-white" data-id="element-284">
        <div className="container mx-auto px-4 text-center" data-id="element-285">
          <h2 className="text-3xl font-bold text-primary mb-6" data-id="element-286">
            Need Urgent Assistance?
          </h2>
          <p className="text-lg text-gray-600 mb-8 max-w-3xl mx-auto" data-id="element-287">
            For immediate help with your appliance issues, call our customer
            service team directly.
          </p>
          <a href="tel:08000554969" className="inline-flex items-center bg-secondary hover:bg-secondary/90 text-white font-bold py-3 px-8 rounded-md text-lg transition-colors" data-id="element-288">
            <Phone size={20} className="mr-2" data-id="element-289" />
            Call 0800 055 4969
          </a>
        </div>
      </section>
    </div>;
};